import { APIClient } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';

export class StockEnumClient extends APIClient {
    public static readonly endpoint = '/stock-api/v1';

    public static async fetchRequirementEntityTypes(): Promise<EntityType[]> {
        const response = await this.fetch(`${this.endpoint}/requirement-entity-types`);
        return await this.handleResponse<EntityType[]>(response);
    }
}
